/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * Exécution en cours, ou dernière exécution, d'une tâche d'import : extraction, validation ou chargement.
 */
export interface ImportRunDto {
    phase?: ImportRunDto.PhaseEnum;
    /** Vrai tant que l'exécution n'a pas posé sa fin (reste vrai si le traitement a été tué : à croiser avec le statut de la tâche). */
    running?: boolean;
    /** Secondes écoulées depuis le lancement (jusqu'à la fin si terminée). */
    elapsedSeconds?: number;
    /** Lignes à traiter au lancement ; absent si inconnu (extraction en flux). */
    toProcess?: number;
    processed?: number;
    pendingAtStart?: number;
    importedAtStart?: number;
    errorsAtStart?: number;
    /** Lignes laissées en attente faute d'avoir obtenu un verrou. */
    locked?: number;
}
export namespace ImportRunDto {
    export type PhaseEnum = 'EXTRACTION' | 'VALIDATION' | 'LOAD';
    export const PhaseEnum = {
        EXTRACTION: 'EXTRACTION' as PhaseEnum,
        VALIDATION: 'VALIDATION' as PhaseEnum,
        LOAD: 'LOAD' as PhaseEnum
    };
}
